var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 459.15,
    height: 549,
    viewBox: "0 0 459.15 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2783",
    x: 0,
    y: 0,
    width: 459.15,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mp3",
    transform: "translate(8404.5 -1541.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-8450 1556.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.5, -15.5)",
    filter: "url(#Path_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783-2",
    "data-name": "Path 2783",
    d: "M365.45,3.125A12.333,12.333,0,0,0,357.159,0H110.9C85.036,0,64,19.135,64,42.667V469.334C64,492.865,85.036,512,110.906,512H439.245c25.869,0,46.9-19.135,46.9-42.667v-352Zm80.665,103.542Z",
    transform: "translate(-45.5 15.5)",
    fill: "#fff",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(-8314.915 1681.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(17.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2793",
    "data-name": "Path 2793",
    d: "M94.375,42.428V181.992a45.9,45.9,0,1,0,15.387,34.365h0V104.2l136.6-34.627v75.376a45.9,45.9,0,1,0,15.388,34.269V0Z",
    transform: "translate(-17.915)",
    fill: "#b0ce47"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.9a7ec12245943d75a65d58a011e62bd8.svg";
export { ForwardRef as ReactComponent };